import { memo } from 'react';

import { Balance } from '../../../models/Base';
import { Profile } from '../../../models/UserStore';
import { AvatarNode, PngIcon } from '../../Molecules';
import './GameStartVSBoard.css';

export type GameStartVSBoardProps = {
  profile: Profile;
  opponentRecords: [];
  reward?: Balance;
};

export const GameStartVSBoard = memo(
  ({ profile, opponentRecords, reward }: GameStartVSBoardProps) => {
    return (
      <div className="vs-board">
        {profile ? (
          <div className="vs-row">
            <AvatarNode
              avatar={{
                ...profile.avatar,
                userId: profile.userId,
                source:
                  profile.profilePicture &&
                  profile.profilePicture.publicUrls?.small
                    ? {
                        uri: profile.profilePicture.publicUrls.small,
                      }
                    : '',
              }}
              size={96}
            />
            {opponentRecords.length > 0 ? <p className="vs-text">VS</p> : null}
            {opponentRecords.map(() => (
              <>TODO: AvatarNode + AI label if is dummy record</>
            ))}
          </div>
        ) : null}
        {reward && !reward.isEmpty ? (
          <div className="rewards-row">
            {reward.joyPoint > 0 && (
              <div className="reward-node">
                <PngIcon name={'JCoin'} className="reward-icon" />
                <p className="reward-text">x{reward.joyPoint}</p>
              </div>
            )}
            {reward.exp > 0 && (
              <div className="reward-node">
                <PngIcon name={'KnowledgeXP'} className="reward-icon" />
                <p className="reward-text">x{reward.exp}</p>
              </div>
            )}
          </div>
        ) : null}
      </div>
    );
  },
);
